import { createContext } from 'react'

const DataProcessTemplateQuestionContext = createContext()

export default DataProcessTemplateQuestionContext
